import { MF_PARTICULAR_HOLDING_DATA, MF_PARTICULAR_HOLDING_ERROR, MF_PARTICULAR_HOLDING_HIDE_ERROR, MF_PARTICULAR_HOLDING_STOP_LOADER, MF_PARTICULAR_HOLDING_START_LOADER, } from "../interface/IMFParticularHolding";
import store from "../../../store";
export default class MFParticularHoldingActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getMfParticularHolding(data) {
        this.dispatch({
            type: MF_PARTICULAR_HOLDING_DATA,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: MF_PARTICULAR_HOLDING_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: MF_PARTICULAR_HOLDING_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: MF_PARTICULAR_HOLDING_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: MF_PARTICULAR_HOLDING_STOP_LOADER,
        });
    }
}
